import { Icon } from '@iconify/react';
import { ArgoFeaturePreviewIcon } from './icons/ArgoFeaturePreviewIcon';
import { GetDxIcon } from './icons/GetDxIcon';
import { GraduationCapIcon } from './icons/GraduationCapIcon';
import { GrowthBookIcon } from './icons/GrowthBookIcon';

const toolkit = [
  {
    label: 'Github',
    url: 'https://github.com/integromat',
    // Monochrome marks follow the text colour; the coloured ones disappear
    // on the dark-mode tile.
    icon: <Icon icon="simple-icons:github" width={32} />,
  },
  {
    label: 'CircleCI',
    url: 'https://app.circleci.com/pipelines/github/integromat',
    icon: <Icon icon="simple-icons:circleci" width={32} />,
  },
  {
    label: 'Datadog',
    url: 'https://app.datadoghq.com/',
    icon: <Icon icon="vscode-icons:file-type-datadog" width={35} />,
  },
  {
    label: 'NPM',
    url: 'https://www.npmjs.com/settings/integromat/packages',
    icon: <Icon icon="logos:npm-icon" width={35} />,
  },
  {
    label: 'ArgoCD',
    url: 'https://argo.mgmt.integromat.org/',
    icon: <Icon icon="devicon:argocd" width={35} />,
  },
  {
    label: 'ArgoCD Feature Previews',
    url: 'https://argo.preview.integromat.org',
    icon: <ArgoFeaturePreviewIcon />,
  },
  {
    label: 'Argo Workflows',
    url: 'https://workflows.mgmt.integromat.org/',
    icon: <Icon icon="devicon:argocd-wordmark" width={35} />,
  },
  {
    label: 'Kargo',
    url: 'https://kargo.mgmt.integromat.org/',
    icon: <img src="/kargo.png" alt="Kargo" width={35} />,
  },
  {
    label: 'Jira',
    url: 'https://integromat.atlassian.net/jira/projects?selectedProjectType=software',
    icon: <Icon icon="logos:jira" width={35} />,
  },
  {
    label: 'Docker Hub',
    url: 'https://hub.docker.com/orgs/integromat/repositories',
    icon: <Icon icon="logos:docker-icon" width={35} />,
  },
  {
    label: 'Make Design Storybook',
    url: 'https://domino.app.mkhq.io/?path=/docs/welcome--docs',
    icon: <Icon icon="vscode-icons:file-type-storybook" width={35} />,
  },
  {
    label: 'Developer Onboarding',
    url: '/docs/default/component/engineering-docs/engineer-onboarding-guide/',
    icon: <GraduationCapIcon />,
  },
  {
    label: 'getDX',
    url: 'https://app.getdx.com/dashboard/org',
    icon: <GetDxIcon />,
  },
  {
    label: 'GrowthBook',
    url: 'https://growthbook.mgmt.integromat.org/',
    icon: <GrowthBookIcon />,
  },
];

export default toolkit;
